import { Component, OnInit } from '@angular/core';
import { TimelineService } from '@services/timeline.service';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CommonPipe } from '@pipes/common.pipe';
import * as _ from 'lodash';
import { fadeInLeftOnEnterAnimation } from 'angular-animations';
@Component({
  selector: 'app-tapps',
  templateUrl: './tapps.component.html',
  styleUrls: ['./tapps.component.sass'],
  animations: [
    fadeInLeftOnEnterAnimation({ anchor: 'fadeInLeft' })
  ]
})
export class TappsComponent implements OnInit {
  application = "";
  component = '';
  entity='';
  response: any = [];
  id = '';
   dataLoding = true;
   total_record=0;
   pageCounter = 1;
   pageno = 1;
   rows=1;
   params:any=[];
   page_load=true;
   appresponse:any=[];
  constructor(private router: Router, private route: ActivatedRoute, private _timelineService: TimelineService, private _global: GlobalService) {
    let pa = this._global.getTimelineAppParam(this.route.snapshot.url[1].path);
    this.rows = this._global.ROWS;
    this.component = pa.c;
    this.id = pa.id;
    this.entity=pa['a']
    let p = {
      'component': this.component,
      'application': 'activities',
      'sortOrder': 'desc',
      'sortString': 'updatedTime',
      entityId:this.id,
      "start": 0,
      "isMember": 'true',
      "isTimeline": 'true',
      "rows": this.rows
    };
    this._timelineService.apps(p,this.entity).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.page_load=false;
          this.params = this._global.getVal(data, 'request', '');
          this.appresponse=this._global.getVal(data, 'response.data',{});
          this.dataLoding = false;
          this.response = data["response"]["docs"];
          this.total_record = this._global.getVal(data, 'response.numFound', '0');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
        this.router.navigate(['']);
      });

  }
  ngOnInit(): void {
  }
  replaceDescription (obj) {
    let str = this._global.getVal(obj, 'description', '');
    let mediaName = this._global.getVal(	obj, 'mediaName', '');
    let entityName = this._global.getVal(obj,	'entityName', '');
		str = str.replace(/\${mediaName}/g,  mediaName );
		str = str.replace(/\${entityName}/g, entityName);
		return str;

	}
  onScrollDown() {
    if (!this.dataLoding) {
      this.dataLoding = true;
      if (this.total_record <= this.pageCounter * this.rows) {
        this.dataLoding = false;
      } else {
        let p = this._global.generateParams(this.params, ['component', 'start', 'language', 'url', 'dialect']);
        p['start'] = this.pageCounter * this.rows;
        p['component'] = this.component;
        this._timelineService.apps(p,this.entity).subscribe(
          data => {
            if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
              this.response = this.response.concat(data["response"]["docs"]);
              this.dataLoding = false;
              this.pageCounter += 1;
              this.params = this._global.getVal(data, 'request', '');
            } else {
              this.dataLoding = false;
            }
          },
          error => {
            console.log("error", JSON.stringify(error));
          });
        //  console.log('scrolled down!!', ev);

      }
    }
  }
}
